import FieldWithTypeMultiSelect from 'routes/ReferralForm/FormView/components/FieldWithTypeMultiSelect/FieldWithTypeMultiSelect';

export default FieldWithTypeMultiSelect;
